<template>
  <div class="agence_detail">
    <violet-bar>Composition de la page "Informations"</violet-bar>
    <div class="box" v-show="show_md_info" style="position: fixed; z-index: 99; width: 700px; height: 200px; left: 50%;top:50%;transform:translate(-50%,-50%)">
      <span class="delete" style="position:absolute;z-index: 2;top:12px;right:12px;cursor:pointer;" @click="show_md_info = 0"></span>
      <div class="message is-info">
        <div class="message-header">
          Mise en page basique via Markdown :
        </div>
        <p class="message-body">
        Faire un retour chariot : deux espaces en fin de ligne<br>
        *texte light*<br>
        [texte du lien](http://adresse-du-lien.com)<br>
      </p>
      </div>
    </div>
    <div class="squarebox">
      <vue-draggable
        :value="blocks"
        @input="blocks = $event"
        :handle="'.handle_i'"
      >
        <div
          class="squarebox"
          v-for="(block, index) in blocks"
          :key="block.uuid"
          style="position:relative; min-height: 60px"
        >
          <span
            class="handle_i"
            style="position:absolute; left: -8px; top: -8px; background: antiquewhite; border-radius: 4px; height: 16px; width: 16px; font-size: 9px; text-align: center"
            >{{ index }}</span
          >
          <div
            class="reordering"
            style="display: flex; flex-direction: column; position: absolute;right: -32px;top:4px;width: 32px;"
          >
            <button
              v-if="block.type === block_types.CAROUSSEL"
              class="button is-danger"
              @click="remove(block.uuid)"
            >
              <i class="icon fa fa-times"></i>
            </button>
          </div>
          <div v-if="block.type === block_types.CAROUSSEL">
            <div>
              <div class="field">
                <label for="" class="label">Titre de ce caroussel</label>
                <input v-model="block.title" type="text" class="input" />
              </div>
              <label for="" class="label">Diapositives</label>
              <div class="squarebox">
                <div>
                  <vue-draggable
                    :value="block.slides"
                    @input="block.slides = $event"
                    class="columns is-multiline"
                    :handle="'.handle_o'"
                  >
                    <div
                      class="column is-one-quarter"
                      v-for="(slide, jndex) in block.slides"
                      :key="slide.uuid"
                    >
                      <div
                        class="squarebox is-relative"
                        style="position:relative;"
                        v-if="slide.type === slide_types.PHOTO"
                      >
                        <span
                          class="handle_o"
                          style="position:absolute; left: -8px; top: -8px; background: antiquewhite; border-radius: 4px; height: 16px; width: 16px; font-size: 9px; text-align: center"
                          >- {{ jndex }}</span
                        >
                        <span
                          class="delete is-small"
                          style="position:absolute; right: 0; top:0;"
                          @click="remove_slide(block.uuid, slide.uuid)"
                        ></span>
                        <label for="" class="label">Légende de la photo</label>
                        <input type="text" class="input" v-model="slide.text" />
                        <label for="" class="label">Photo</label>
                        <picture-input
                          :item="
                            slide.content.picture && slide.content.picture.id
                          "
                          @update="slide.content.picture = $event"
                        ></picture-input>
                        <label for="" class="label"
                          >URL du lien (ou laisser vide)</label
                        >
                        <input type="text" class="input" v-model="slide.link" />
                      </div>
                      <div
                        class="squarebox is-relative"
                        style="position:relative;"
                        v-if="slide.type === slide_types.VIDEO"
                      >
                        <span
                          class="handle_o"
                          style="position:absolute; left: -8px; top: -8px; background: antiquewhite; border-radius: 4px; height: 16px; width: 16px; font-size: 9px; text-align: center"
                          >- {{ jndex }}</span
                        >
                        <span
                          class="delete is-small"
                          style="position:absolute; right: 0; top:0;"
                          @click="remove_slide(block.uuid, slide.uuid)"
                        ></span>
                        <label for="" class="label"
                          >Code d'intégration vidéo</label
                        >
                        <textarea
                          class="textarea is-small "
                          id=""
                          cols="30"
                          rows="5"
                          v-model="slide.content.integration_code"
                        ></textarea>
                      </div>
                    </div>
                  </vue-draggable>
                </div>
                <div class="buttons" style="margin-top: 1em">
                  <button
                    class="button is-small is-primary"
                    @click="addTo(block, slide_types.VIDEO)"
                  >
                    Ajouter une diapositive VIDÉO
                  </button>
                  <button
                    class="button is-small is-primary"
                    @click="addTo(block, slide_types.PHOTO)"
                  >
                    Ajouter une diapositive IMAGE
                  </button>
                </div>
              </div>
              <label for="" class="label"
                >Texte sous ce caroussel : mise en forme <span class="tag is-info" style="cursor:pointer;" @click="show_md_info = 1">MARKDOWN</span>
                <span
                  v-if="block.text"
                  :class="{
                    'has-text-danger': block.text && block.text.length > 450
                  }"
                  >({{ block.text.length }} / 450)</span
                ></label
              >
              <textarea
                name=""
                id=""
                cols="30"
                rows="5"
                class="textarea is-small "
                v-model="block.text"
              ></textarea>
              <label for="" class="label">Téléchargeables</label>
              <div class="squarebox">
                <div class="columns is-multiline">
                  <div class="column is-one-fifth" v-for="download in block.downloads || []" :key="download.uuid || 'empty_list'">
                    <div class="squarebox is-relative">
                      <span class="delete is-small" @click="removeDownloadable(block, download.uuid)"></span>
                      <div v-if="!download.content.file">
                        <file-upload-input :binary="true" :label="'Chargez un PDF ici'" :sublabel="''" @file="register_file(download, $event)"></file-upload-input>
                      </div>
                      <div v-if="download.content.file">
                        <button class="button is-light" disabled>{{ download.content.name }}</button>
                        <label for="" class="label">Texte du lien de téléchargement</label>
                        <input type="text" class="input is-small" v-model="download.content.link">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="button is-primary" @click="addDownloadable(block)">Ajouter un Téléchargeable</div>
            </div>
          </div>
          <div v-if="block.type === block_types.PUBLICATIONS">
            <div
              class="tag is-big is-info"
              style="height: 48px; display: block; margin: auto; font-size: 24px;"
            >
              Partie Publications
            </div>
          </div>
          <div v-if="block.type === block_types.CV">
            <div
              class="tag is-big is-info"
              style="height: 48px; display: block; margin: auto; font-size: 24px;"
            >
              Partie CVs
            </div>
          </div>
          <div v-if="block.type === block_types.PRESENTATION">
            <div
              class="tag is-big is-info"
              style="height: 48px; display: block; margin: auto; font-size: 24px;"
            >
              Partie Présentation
            </div>
          </div>
          <div v-if="block.type === block_types.WORKERS">
            <div
              class="tag is-big is-info"
              style="height: 48px; display: block; margin: auto; font-size: 24px;"
            >
              Partie Liste des équipiers
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="button is-primary" @click="add">
            Ajouter une section CAROUSSEL
          </button>
        </div>
      </vue-draggable>
    </div>
    <div class="buttons">
      <button class="button is-small is-primary" @click="save">
        Enregistrer
      </button>
    </div>
  </div>
</template>

<script>
import VioletBar from "../Projects/VioletBar";
import { genUuidV4 } from "../../util/uuidv4";
import PictureInput from "../../components/Form/PictureInput";
import VueDraggable from "vuedraggable";
import { types } from "../../store/actions/misc";
import FileUploadInput from "../../components/Form/UploadInput";

const block_types = {
  CAROUSSEL: "CAROUSSEL",
  PUBLICATIONS: "PUBLICATIONS",
  PRESENTATION: "PRESENTATION",
  WORKERS: "WORKERS",
  CV: "CV"
};

const slide_types = {
  PHOTO: "PHOTO",
  VIDEO: "VIDEO"
};

const slide_constructor = type => ({
  type: type || slide_types.PHOTO,
  content: {
    integration_code: "",
    picture: "",
    link: ""
  },
  text: "",
  uuid: genUuidV4()
});

const download_constructor = () => ({
  type: "DOWNLOADABLE",
  content: {
    link: "",
    file: "",
    name: "",
    hash: ""
  },
  uuid: genUuidV4(),
});

const block_constructors = {
  [block_types.CAROUSSEL]: () => ({
    type: block_types.CAROUSSEL,
    title: "",
    text: "",
    show: true,
    uuid: genUuidV4(),
    slides: [slide_constructor()],
    downloads: [download_constructor()]
  }),
  [block_types.PUBLICATIONS]: () => ({
    type: block_types.PUBLICATIONS,
    show: true,
    uuid: genUuidV4()
  }),
  [block_types.PRESENTATION]: () => ({
    type: block_types.PRESENTATION,
    show: true,
    uuid: genUuidV4()
  }),
  [block_types.CV]: () => ({
    type: block_types.CV,
    show: true,
    uuid: genUuidV4()
  }),
  [block_types.WORKERS]: () => ({
    type: block_types.WORKERS,
    show: true,
    uuid: genUuidV4()
  })
};

export default {
  name: "agence_detail",
  components: {FileUploadInput, PictureInput, VioletBar, VueDraggable },
  data() {
    return {
      show_md_info: 0,
      block_types,
      slide_types,
      blocks: [
        block_constructors[block_types.PRESENTATION](),
        block_constructors[block_types.PUBLICATIONS](),
        block_constructors[block_types.WORKERS]()
      ]
    };
  },
  computed: {
    has_cv() {
      return this.blocks.findIndex(b => b.type === block_types.CV) !== -1;
    }
  },
  methods: {
    async save() {
      this.blocks = await this.$store.dispatch(
        types.SET_DETAILED_AGENCE,
        this.blocks
      );
    },
    show_md_info() {

    },
    add_cv() {
      this.blocks.push(block_constructors[block_types.CV]);
    },
    async fetch() {
      return this.$store.dispatch(types.GET_DETAILED_AGENCE);
    },
    add() {
      this.blocks.push(block_constructors[block_types.CAROUSSEL]());
    },
    remove(uuid) {
      this.blocks = this.blocks.filter(b => b.uuid !== uuid);
    },
    toggle(block) {
      block.show = !block.show;
    },
    up(uuid) {
      const i = this.blocks.findIndex(b => b.uuid === uuid);
      if (i === -1) return;
      if (i === 0) return;
      this.blocks.splice(i - 1, 0, this.blocks.splice(i, 1));
    },
    addTo(block, type) {
      block.slides.push(slide_constructor(type));
    },
    addDownloadable(block) {
      if (typeof block.downloads === "undefined") {
        this.$set(block, 'downloads', []);
      }
      block.downloads.push(download_constructor());
    },
    register_file(download, file) {
      download.content.file = file.path;
      download.content.name = file.name;
      download.content.hash = file.hash;
    },
    removeDownloadable(block, uuid) {
      block.downloads = block.downloads.filter(d => d.uuid !== uuid);
    },
    down(uuid) {
      const i = this.blocks.find(b => b.uuid === uuid);
      if (i === -1) return;
      if (i === this.blocks.length - 1) return;
      this.blocks.splice(i, 0, this.blocks.splice(i, 1));
    },
    remove_slide(uuid, uuid2) {
      this.blocks = this.blocks.map(block => {
        if (block.uuid !== uuid) return block;
        return { ...block, slides: block.slides.filter(a => a.uuid !== uuid2) };
      });
    }
  },
  async mounted() {
    try {
      this.blocks = await this.fetch();
      this.$nextTick(() => {
        if (!this.has_cv) {
          this.add_cv();
        }
      });
    } catch (e) {
      this.blocks = [
        block_constructors[block_types.PRESENTATION](),
        block_constructors[block_types.PUBLICATIONS](),
        block_constructors[block_types.WORKERS](),
        block_constructors[block_types.CV]()
      ];
    }
  }
};
</script>
